import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useI18n } from '../content/i18n';
import './MimickingSection.css';

gsap.registerPlugin(ScrollTrigger);

const MimickingSection = () => {
  const { t } = useI18n();
  const sectionRef = useRef(null);
  const subtitleRef = useRef(null);
  const titleRef = useRef(null);
  const buttonsRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        subtitleRef.current,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 70%',
            end: 'top 50%',
            scrub: 1,
          },
        }
      );

      gsap.fromTo(
        titleRef.current,
        { opacity: 0, scale: 0.9 },
        {
          opacity: 1,
          scale: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 60%',
            end: 'top 40%',
            scrub: 1,
          },
        }
      );

      gsap.fromTo(
        buttonsRef.current,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 50%',
            end: 'top 30%',
            scrub: 1,
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="mimicking-section" ref={sectionRef}>
      <div className="mimicking-content container">
        <p className="mimicking-subtitle" ref={subtitleRef}>
          {t.mimicking.subtitleLines[0]}<br />{t.mimicking.subtitleLines[1]}
        </p>
        <h2 className="mimicking-title" ref={titleRef}>
          <span className="mimicking-brand">{t.mimicking.mimickingText}</span>
          {t.mimicking.titleSuffixLines[0]}<br />{t.mimicking.titleSuffixLines[1]}
        </h2>
        
        <div className="download-buttons" ref={buttonsRef}>
          <a 
            href="https://apps.apple.com/us/app/mimic-%EB%AF%B8%EB%AF%B9/id6756565040" 
            target="_blank" 
            rel="noopener noreferrer"
            className="button button--primary download-button ios-button"
            aria-label={t.hero.iosAriaLabel}
          >
            <svg className="button-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </svg>
            <div className="button-text">
              <span className="button-label">{t.hero.iosLabel}</span>
              <span className="button-store">{t.hero.iosStore}</span>
            </div>
          </a>
          <a 
            href="https://play.google.com/store/apps/details?id=com.benefitbros.mimic" 
            target="_blank" 
            rel="noopener noreferrer"
            className="button button--primary download-button android-button"
            aria-label={t.hero.androidAriaLabel}
          >
            <svg className="button-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
            </svg>
            <div className="button-text">
              <span className="button-label">{t.hero.androidLabel}</span>
              <span className="button-store">{t.hero.androidStore}</span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default MimickingSection;

